<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='#'>{{ translations('navbar.purchase_management') }}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-return-partners'>{{ translations('return_partner.archive_manufacturer_return') }}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{ translations('return_partner.return_partner_detail') }}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{ translations('return_partner.applied_date') }}</th>
                <td v-if="isLastConfirm == '0'">
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnInfo.applied_at) || '----------'}}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('return_partner.applied_date') }}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_applied' class='form-control input-date'>
                      <input type='time' v-model='time_applied' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('applied_at',`${date_applied} ${time_applied}`,'info01')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >OK</button>
                    </div>
                  </div>
                </td>
                <td v-else>{{$invoiceTools.formatDateHours(returnInfo.applied_at)}}</td>
              </tr>
              <tr>
                <th>{{ translations('return_partner.shipped_date') }}</th>
                <td v-if="isLastConfirm == '0'">
                  <button
                    ref='info02'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info02'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnInfo.shipped_at) || '----------'}}</button>
                  <div id='popover-info02' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('return_partner.shipped_date') }}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_shipped' class='form-control input-date'>
                      <input type='time' v-model='time_shipped' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('shipped_at',`${date_shipped} ${time_shipped}`,'info02')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >OK</button>
                    </div>
                  </div>
                </td>
                <td v-else>{{$invoiceTools.formatDateHours(returnInfo.shipped_at)}}</td>
              </tr>
              <tr>
                <th>{{ translations('return_partner.approved_date') }}</th>
                <td v-if="isLastConfirm == '0'">
                  <button
                    ref='info05'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info05'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnInfo.approved_at) || '----------'}}</button>
                  <div id='popover-info05' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('return_partner.approved_date') }}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_approved' class='form-control input-date'>
                      <input type='time' v-model='time_approved' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('approved_at',`${date_approved} ${time_approved}`,'info05')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >OK</button>
                    </div>
                  </div>
                </td>
                <td v-else>{{$invoiceTools.formatDateHours(returnInfo.approved_at)}}</td>
              </tr>
              <tr>
                <th>{{ translations('return_partner.offset_date') }}</th>
                <td v-if="isLastConfirm == '0'">
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnInfo.offset_at) || '----------'}}</button>
                  <div id='popover-info06' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('return_partner.offset_date') }}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_offset' class='form-control input-date'>
                      <input type='time' v-model='time_offset' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('offset_at',`${date_offset} ${time_offset}`,'info06')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >OK</button>
                    </div>
                  </div>
                </td>
                <td v-else>{{$invoiceTools.formatDateHours(returnInfo.offset_at)}}</td>
              </tr>
              <tr>
                <th>{{ translations('return_partner.organization_number') }}</th>
                <td>{{returnInfo.reference_number}}</td>
              </tr>
              <tr>
                <th>{{ translations('return_partner.product_origin') }}</th>
                <td>{{ productOrigin(returnInfo.is_domestic)}}</td>
              </tr>
              <tr>
                <th>{{ translations('return_partner.affects_inventory') }}</th>
                <td>{{ affectsInventory(returnInfo.affects_inventory) }}</td>
              </tr>
              <tr>
                <th>{{translations('return_partner.manufacturer')}}</th>
                <td>{{ returnInfo.partner_name }}</td>
              </tr>
              <tr>
                <th>{{ translations('return_partner.remarks') }}</th>
                <td>
                  <button
                    ref='info04'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info04'
                    data-placement='right'
                  >{{ returnInfo.memo || '----------' }}</button>
                  <div id='popover-info04' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('return_partner.remarks') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.memo" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info04')">{{ translations('common.update') }}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('common.last_updated_by') }}</th>
                <td>{{returnInfo.updated_by}}</td>
              </tr>
              <tr>
                <th>{{ translations('common.last_update_time') }}</th>
                <td>{{ $invoiceTools.formatDateTime(returnInfo.updated_at) }}</td>
              </tr>
              <tr>
                <th class="is_processed">{{ translations('return_partner.processing_status') }}</th>
                <td>
                  <button type="button" class="btn btn-primary btn-sm" v-if="Number(returnInfo.is_processed) === 0" v-on:click="clickIsProcessed()" :disabled="true">
                    {{ translations('return_partner.mark_processed') }}</button>
                  <button type="button" class="btn btn-primary btn-sm" v-else v-on:click="clickIsProcessed()" :disabled="true">{{ translations('return_partner.revert_unprocessed') }}</button>
                </td>
              </tr>
              <tr>
                <th>{{ Number(returnInfo.closing_flag) ? translations('return_partner.closing_date') : translations('return_partner.scheduled_closing_date') }}</th>
                <td>{{ $invoiceTools.formatDateTime(returnInfo.closing_at) }}</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deleteReturn()" href='javascript:;'>{{ translations('common.delete') }}</a>
            </div>
          </div>
          <hr>
          <!-- UPLOAD TEMPLATE -->
          <div class="upload-file-evident">
            <input @change="selectFileEvident" ref="inputUploadFile" type="file" multiple class="mr-2" accept="application/pdf, image/png, image/jpeg, image/jpg">
            <button @click="uploadFileEvident" class="v-btn v-btn--contained theme--light v-size--small mt-2">{{ translations('return_partner.upload') }}</button>
          </div>
           <button v-if="evidentList.length" class="btn v-btn v-btn--contained mt-2" @click="showModalReturnFile">
             {{ translations('return_partner.files') }}</button>
          <!-- UPLOAD TEMPLATE -->
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end">
            <div class="form-group mr-3">
              <span class="font-weight-bold mb-0" style="font-size:16px;">{{ translations('return_partner.unit_price_total') }}： {{ displayGrandTotal(grandTotalUnitPriceDetail, grandTotalUnitPriceIncTaxDetail) }}  </span>
            </div>
            <div class="form-group">
              <span class="font-weight-bold mb-0" style="font-size:16px;">{{ translations('return_partner.total_liabilities') }}： {{ displayGrandTotal(grandTotalDebtDetail, grandTotalDebtIncTaxDetail) }}  </span>
            </div>
          </div>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{ translations('common.tax_included') }}</div><!-- TAXSTATUS -->
            <div v-else>{{ translations('common.tax_excluded') }}</div>
          </div>
          <div class='table-scroll mb-2'>
            <table class='table table-sm table-striped table-1500 table-align-middle'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{ translations('return_partner.product_condition') }}</th>
                  <th>{{ translations('return_partner.warehouse') }}</th>
                  <th>{{ translations('return_partner.verification_results') }}</th>
                  <th>{{ translations('return_partner.model_number') }}</th>
                  <th>{{ translations('return_partner.tax_classification') }}</th><!-- TAXSTATUS -->
                  <th>{{ translations('return_partner.number_item') }}</th>
                  <th class="width-50-px">{{ translations('return_partner.unit_price') }}</th>
                  <th class="width-50-px"></th>
                  <th>{{ translations('return_partner.original_unit_price') }}</th>
                  <th>{{ translations('return_partner.summary') }}</th>
                  <th>{{ translations('return_partner.unit_price_total') }}</th>
                  <th>{{ translations('return_partner.total_liabilities') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for='(detail, i) in returnDetails'>
                  <tr v-if="Number(detail.set_status) !== 2" :key='i'>
                    <td>
                      <!-- 未処理のみ削除可能 -->
                      <button v-if="isLastConfirm == '0'" for="checkStatus" @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td>
                      {{ typeProduct(detail.type_product_id) }}
                    </td>
                    <td>
                      {{ detail.warehouse_name ? detail.warehouse_name : detail.warehouse.name }}
                    </td>
                    <td>
                      <button
                        type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-test_result' + i"
                        data-placement='right'
                        style="max-width: 150px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                        :title="getTextResult(detail)"
                      >{{getTextResult(detail)}}</button>
                      <div :ref="'popover-test_result' + i" :id="'popover-test_result' + i" class='popover popover-default popover-x has-footer'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'>
                          <button class='close' data-dismiss='popover-x'>×</button>
                          {{ translations('return_partner.verification_results') }}
                        </div>
                        <div class='popover-body popover-content'>
                          <textarea class='form-control' v-model="tempDetails[i].test_result"></textarea>
                        </div>
                        <div class='popover-footer'>
                          <button @click="onChangeTestResult(detail, i)" type='submit' class='btn btn-sm btn-primary'>OK</button>
                        </div>
                      </div>
                      <div class='popover-x-marker' style='display: none;'></div>
                    </td>

                    <td>{{detail.model ? detail.model : '-------' }}</td>

                    <td v-if="!Number(returnInfo.closing_flag) && detail.is_shipped_replacement === 0">
                      <select
                       :disabled="false"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onChangeTaxclass(detail)">
                        <option value="1">{{ translations('return_partner.taxable_item') }}</option>
                        <option value="2">{{ translations('return_partner.not_applicable') }}</option>
                      </select>
                    </td><!-- TAXSTATUS -->
                    <td v-else>{{ detail.taxclass_id === 1 ? translations('return_partner.taxable_item') : translations('return_partner.not_applicable') }}</td>

                    <td class="right">{{ detail.quantity.toLocaleString() }}</td>

                    <td v-if="isLastConfirm == '0'">
                      <div v-if="!taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price" :id="'unit_price' + i" @focus="refresh('unit_price' + i)" @blur="refresh('unit_price' + i)" @input="onChangePrice('unit_price', detail)" @change="onChangeUnitPrice(detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price && detail.unit_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                      <div v-if="taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price_inctax" :id="'unit_price_inctax' + i" @focus="refresh('unit_price_inctax' + i)" @blur="refresh('unit_price_inctax' + i)" @input="onChangePrice('unit_price_inctax', detail)" @change="onChangeUnitPrice(detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price_inctax && detail.unit_price_inctax.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                    </td>
                    <td v-else>
                      <div v-if="!taxIncluded"><!-- input 含む number-container ブロック -->
                        {{ detail.unit_price.toLocaleString() }}
                      </div>
                      <div v-if="taxIncluded"><!-- input 含む number-container ブロック -->
                        {{ detail.unit_price_inctax.toLocaleString() }}
                      </div>
                    </td>

                    <td v-if="Number(detail.taxclass_id) === 1" class="right">
                      ({{ toUnitPriceTaxLabel(detail) }})
                    </td>
                    <td v-else></td>

                    <td class="right" >
                        <span>{{ detail.row_price && detail.row_price.toLocaleString() }}</span>
                    </td>

                    <td class="right">
                      <input type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.remarks" @change="onChangeRemarks(detail)"/>
                    </td>

                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_cost') }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td v-if="isLastConfirm === '0'">
                    <button @click="openAddDetailModal()" class='btn-change plus' type='button'><i></i></button>
                    <button ref="openAddDetailModal" hidden="true" class='btn-change plus' type='button' data-toggle='modal' data-target='#NewReturnPartnersModal'><i></i></button>
                  </td>
                  <td v-else></td>
                  <td colspan="10"></td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalDebt, grandTotalDebtIncTax) }}</td>
                </tr>
              </tbody>
            </table>
            <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
          </div>
          <div class="form-inline mb-4">
            <div class="form-group">
              <button :disabled="isLastConfirm === '1'" class='btn btn-sm btn-primary' @click="confirmLastReturn()">{{ isLastConfirm === '1' ? translations('return_partner.confirmed') : translations('return_partner.confirm')}}</button>
              <div v-if="!Number(returnInfo.closing_flag)" class='form-group ml-2'>
                <!-- 追加か削除された場合にのみ有効化 -->
                <button :disabled="!isAddOrDelete" @click="updateReturn()" class='btn btn-sm btn-primary'>{{ translations('common.update') }}</button>
              </div>
            </div>
          </div>

          <div class='form-inline form-line-po'>
          </div>
        </div>
      </div>
    </div>
    <NewReturnPartnersModal
      :returnDetails='returnDetails'
      :returnWarehouses="master_mywarehouses"
      :partnerId="tempInfo.manufacturers"
      :arrivedDate="date_applied"
      :vat="{taxIncluded:taxIncluded, vatRate:vatRate}"
    /><!-- VAT -->
    <SingleReturnsModal :setItems="setItems" :return_id="returnPartnerId" :returnDetails='returnDetails'/>
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
    <ReturnDownloadFilesModal ref="returnModalComponent" :setEvidentFileDelete="setEvidentFileDelete"/>

  </div>
</template>

<script>
import $ from 'jquery' // number-container
import { format } from 'date-fns'
import VueElementLoading from 'vue-element-loading'
import NewReturnPartnersModal from '@/components/NewReturnPartnersModal'
import SingleReturnsModal from '@/components/SingleReturnModal'
import ReturnDownloadFilesModal from '@/components/ReturnDownloadFilesModal'
import _ from 'lodash'
import { Condition, ReasonReturn } from '@/constants'
import { mapState } from 'vuex'

export default {
  name: 'SingleReturnPartners',
  props: {},
  components: {
    VueElementLoading,
    NewReturnPartnersModal,
    SingleReturnsModal,
    ReturnDownloadFilesModal
  },
  watch: {
    returnDetails: {
      handler (v) {
        this.tempDetails = JSON.parse(JSON.stringify(v))
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })
        this.calcGrandTotals()
        this.withSetItem()
        this.refresh('row_price') // 原価
        setTimeout(() => {
          this.popoverButtons()
        }, 1000)
      },
      deep: true
    },
    allReturnDetails: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareTotalDetails(d)
          }
        })
        this.calcGrandTotalsDetail()
        this.refresh('row_price') // 原価
        setTimeout(() => {
          this.popoverButtons()
        }, 1000)
      },
      deep: true
    },
    'tempInfo.bill_to_id' (newId, oldId) {
      if ((newId && oldId) && (newId.id === oldId.id)) return

      if (oldId) {
        this.tempInfo.destinations_id = {
          name: '',
          id: '0'
        }
        this.updateField('destinations_id', '', 'info04')
      }
    },
    page () {
      this.changeIds = []
      this.getReturnDetails()
      window.scrollTo(0, 0)
    }
  },
  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT // TAXSTATUS (TROUBLESHOOTING)
      returnPartnerId: '',
      isLoading: false,
      returnInfo: {},
      returnDetails: [],
      tempInfo: {},
      tempDetails: [],
      originalInfo: {},
      originalDetails: [],
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalDebt: 0,
      grandTotalDebtIncTax: 0,
      grandTotalUnitPriceDetail: 0,
      grandTotalUnitPriceIncTaxDetail: 0,
      grandTotalDebtDetail: 0,
      grandTotalDebtIncTaxDetail: 0,
      setItems: [],
      selectedDetail: null,
      clickAddDetail: false,
      deliveryFile: null,
      changeIds: [],
      date_applied: format(new Date(), 'yyyy-MM-dd'),
      time_applied: format(new Date(), 'HH:mm'),
      date_shipped: format(new Date(), 'yyyy-MM-dd'),
      time_shipped: format(new Date(), 'HH:mm'),
      date_approved: format(new Date(), 'yyyy-MM-dd'),
      time_approved: format(new Date(), 'HH:mm'),
      date_offset: format(new Date(), 'yyyy-MM-dd'),
      time_offset: format(new Date(), 'HH:mm'),
      evidentFile: [],
      evidentList: [],
      isConfirmReturn: false,
      adminStatus: [],
      isShowButtonApproved: false,
      isApprivedDisable: false,
      isShowLastConfirm: false,
      isLastConfirm: false,
      page: 1,
      totalCount: 0,
      itemsPerPage: 300,
      pageCount: 1,
      allReturnDetails: [],
      returnDetailsCurrentPage: [],
      forceChange: false,
      personals: []
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    return_reasons () {
      return this.$store.getters['Return/getReasons']
    },
    return_states () {
      const states = this.$store.getters['Return/getStates']
      return this.translateStates(states)
    },
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    isAddOrDelete () {
      return JSON.stringify(this.returnInfo) !== JSON.stringify(this.originalInfo) || JSON.stringify(this.returnDetails.map(detail => detail.id)) !== JSON.stringify(this.originalDetails.map(detail => detail.id))
    },
    hasSetItem () {
      return this.returnDetails.filter(detail => detail.set_status === 1).length > 0
    },
    isChangeIds () {
      return this.changeIds.length > 0
    },
    reasons () {
      const returnReasons = this.$store.getters['Return/getReasons']
      let reasons = []
      returnReasons.forEach(reason => {
        if (reason['is_temporary'] === ReasonReturn.reason) {
          reasons.push(reason)
        }
      })
      return reasons
    },
    translationAffectsInventory () {
      const affectsInventory = [
        { id: '0', name: 'return_partner.not_reflect' },
        { id: '1', name: 'return_partner.reflect' }
      ]
      return affectsInventory.map(affectInventory => ({
        ...affectInventory,
        name: this.translations(affectInventory.name)
      }))
    }
  },
  created: async function () {
    if (!this.$route.query.return_partner_id) {
      this.$router.replace('archive-return-partners')
      return
    }

    this.returnPartnerId = this.$route.query.return_partner_id

    this.$store.dispatch('Return/checkReasons')
    this.$store.dispatch('Return/checkStates')
    this.$store.dispatch('Master/checkMywarehouses')

    this.getReturnDetails().catch(error => {
      this.$toastr.error(error.message, this.translations('common.error'))
    }).finally(() => {
      this.popoverButtons()
    })

    await this.listPersonals()
  },
  mounted () {
    let pageBack = this.$router.history.current.query.pageBack
    if (pageBack) {
      window.onpopstate = () => {
        window.location.href = `archive-return-partners?page=${pageBack}`
        return false
      }
    }
    this.getAllReturnDetail()
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(`states.${state.name}`)
      }))
    },
    confirmLastReturn () {
      if (this.isLastConfirm === '1') {
        return false
      }

      if (!this.originalInfo.offset_at) {
        this.$toastr.warning(this.translations('return_partner.notice_offset_date'))
        return
      }

      this.$dialog.confirm(this.translations('return_partner.notice_confirm_return'), {
        okText: this.translations('common.yes'),
        cancelText: this.translations('common.no')
      }).then(async () => {
        let paramUpdate = {
          return_partner_id: this.returnPartnerId,
          details: this.returnDetails,
          offset_date: this.returnInfo.offset_at,
          partner_id: this.returnInfo.partner_id
        }

        if (Number(this.returnInfo.affects_inventory) === 1) {
          this.isLoading = true
          const result = await this.checkQuantityProduct(paramUpdate)

          if (result.status && Object.keys(result).length > 1) {
            const warnings = Object.keys(result)
              .filter((key) => key !== 'status')
              .map((key) => {
                const [jan, warehouse, typeProduct] = result[key]
                return this.translations('return_partner.warehouse') + ' "' + warehouse + '" ' +
                  this.translations('return_partner.to_product') + ' "' + jan + '" ' +
                  ' "' + this.typeProduct(typeProduct) + '" ' + this.translations('return_partner.not_enough')
              })

            warnings.forEach((warning) => this.$toastr.warning(warning))
            this.isLoading = false
            return
          }
          this.isLoading = false
        }

        try {
          this.isLoading = true
          this.$http.post(this.$api_url.return_partner_last_confirm_change_status, paramUpdate)
            .then((response) => {
              const result = response.data
              if (result.status) {
                this.isLastConfirm = '1'
                window.location.reload()
                this.$toastr.success(
                  this.translations('return_partner.notice_update_reflect_inventory_success'),
                  this.translations('return_partner.success')
                )
                this.isLoading = false
              } else {
                this.$toastr.error(result.message, this.translations('return_partner.processing_failed'))
                this.isLoading = false
              }
            }).finally(() => {
              this.isLoading = false
            })
        } catch (error) {
          this.isLoading = false
        }
      })
    },

    async checkQuantityProduct (params) {
      try {
        const response = await this.$http.post(this.$api_url.return_partner_check_quantity_product, params)
        return response.data
      } catch (error) {
        console.error('checkQuantityProduct:error', this.translations('common.error'))
        this.$toastr.error(this.translations('return_partner.notice_failed'), this.translations('common.error'))
        return null
      }
    },
    adminApprove () {
      this.isLoading = true
      const formData = new FormData()
      formData.append('return_id', this.returnPartnerId)
      formData.append('url_return', window.location.href)
      formData.append('created_by', this.returnInfo.created_by)

      this.$http.post(this.$api_url.return_admin_approve_email, formData).then(response => {
        this.isLoading = false
        const result = response.data
        if (!result || result.status !== true) {
          this.$toastr.error(this.translations('return_partner.message_error') + result.message, this.translations('common.error'))
        } else {
          this.isApprivedDisable = true
          let defaultStatus = this.adminStatus
          for (let index = 0; index < defaultStatus.length; index++) {
            if (this.$store.getters['User/data']['email'] === defaultStatus[index].email) {
              defaultStatus[index].status = '1'
            }
          }
          this.adminStatus = defaultStatus
          if (result.open_last_confirm === true) {
            this.isLastConfirm = '0'
            this.isShowLastConfirm = true
          }
        }
      })
    },
    askAdminReview () {
      this.isLoading = true
      const formData = new FormData()
      formData.append('url_return', window.location.href)
      formData.append('return_id', this.returnPartnerId)
      this.$http.post(this.$api_url.return_ask_admin_email, formData).then(response => {
        this.isLoading = false
        const result = response.data
        if (!result || result.status !== true) {
          this.$toastr.error(this.translations('return_partner.message_error') + result.message, this.translations('common.error'))
        } else {
          let defaultStatus = this.adminStatus
          for (let index = 0; index < defaultStatus.length; index++) {
            defaultStatus[index].status = '0'
          }
          this.adminStatus = defaultStatus
          this.isLastConfirm = '0'
          this.isShowLastConfirm = false
          this.isConfirmReturn = true
          this.$toastr.success(this.translations('return_partner.notice_send_mail_success'), this.translations('common.success'))
        }
      })
    },
    selectFileEvident (e) {
      e.preventDefault()
      const files = e.target.files
      this.evidentFile = files
    },
    showModalReturnFile () {
      this.$refs.returnModalComponent.setFiles(this.evidentList)
      window.$('#returnDownloadFilesModal').modal('show')
    },
    uploadFileEvident () {
      let validate = this.validateFileUpload()

      if (validate.result === false) {
        alert(validate.message)
        this.$refs.inputUploadFile.value = null
        return false
      }

      const formData = new FormData()
      formData.append('return_id', this.returnPartnerId)
      for (let index = 0; index < this.evidentFile.length; index++) {
        formData.append('files[]', this.evidentFile[index])
      }
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      this.isLoading = true
      this.$http.post(this.$api_url.return_upload_evident, formData, config).then(response => {
        const result = response.data
        this.$refs.inputUploadFile.value = null
        if (!result || result.status !== true) {
          this.$toastr.error(this.translations('return_partner.message_error') + result.message, this.translations('common.error'))
        } else {
          this.evidentList = result.data
          this.$toastr.success(this.translations('return_partner.notice_upload_success'), this.translations('common.success'))
        }
      }).catch(err => {
        this.$toastr.error(this.translations('return_partner.message_error') + err.message, this.translations('common.error'))
      }).finally(() => {
        this.isLoading = false
        this.evidentFile = []
      })
    },
    validateFileUpload () {
      if (this.$refs.inputUploadFile.files.length > 10) {
        return {
          'message': 'アップロード可能なファイル数は10ファイルまでです。',
          'result': false
        }
      }
      let size = 0
      for (let index = 0; index < this.$refs.inputUploadFile.files.length; index++) {
        size += this.$refs.inputUploadFile.files[index].size
      }
      size = size / 1024 / 1024
      if (size > 20) {
        return {
          'message': 'アップロード可能なファイルは20MB以下のファイルです。',
          'result': false
        }
      }
      if (!this.evidentFile || this.evidentFile.length === 0) {
        return {
          'message': 'ファイルを選択してください',
          'result': false
        }
      }

      for (let index = 0; index < this.evidentFile.length; index++) {
        let type = this.evidentFile[index].type
        let listFile = [ 'application/pdf', 'image/png', 'image/jpeg', 'image/jpg' ]
        if (listFile.indexOf(type) === -1) {
          return {
            'message': 'ファイルフォーマットエラー',
            'result': false
          }
        }
      }
      return {
        'result': true
      }
    },
    setEvidentFileDelete (data) {
      this.evidentList = data
    },
    getReturnDetails () {
      this.isLoading = true
      const offset = (this.page - 1) * this.itemsPerPage
      let params = {
        offset: offset,
        limit: this.itemsPerPage,
        return_partner_id: this.returnPartnerId
      }
      return this.$http.post(this.$api_url.return_partner_details, params).then(response => {
        const result = response.data
        this.returnDetailsCurrentPage = result.details
        this.totalCount = Number(result.total_count)
        this.pageCount = _.ceil(this.totalCount / this.itemsPerPage)
        if (result.status === true) {
          this.returnInfo = result.information
          let details = result.details.map(function (elem) {
            elem.print = false
            elem.status = false
            return elem
          })
          this.returnDetails = details
          this.returnDetails = result.details
          this.evidentList = result.fileEvident
          this.adminStatus = result.adminStatus
          this.taxIncluded = result.information.tax_included
          this.vatRate = result.information.tax_rate

          this.tempInfo = JSON.parse(JSON.stringify(this.returnInfo))
          this.tempDetails = JSON.parse(JSON.stringify(this.returnDetails))

          this.tempInfo.manufacturers = {
            id: this.tempInfo.partner_id,
            name: this.tempInfo.partner_name
          }
          this.tempInfo.requester = {
            id: this.tempInfo.requester_id,
            name: this.tempInfo.requester_name
          }

          this.originalInfo = JSON.parse(JSON.stringify(this.returnInfo))
          this.originalDetails = JSON.parse(JSON.stringify(this.returnDetails))

          this.date_applied = format(new Date(result.information.applied_at), 'yyyy-MM-dd')
          this.time_applied = format(new Date(result.information.applied_at), 'HH:mm')
          this.date_shipped = result.information.shipped_at ? format(new Date(result.information.shipped_at), 'yyyy-MM-dd') : this.date_shipped
          this.time_shipped = result.information.shipped_at ? format(new Date(result.information.shipped_at), 'HH:mm') : this.time_shipped
          this.date_approved = format(new Date(result.information.approved_at), 'yyyy-MM-dd')
          this.time_approved = format(new Date(result.information.approved_at), 'HH:mm')
          this.date_offset = result.information.offset_at ? format(new Date(result.information.offset_at), 'yyyy-MM-dd') : this.date_offset
          this.time_offset = result.information.offset_at ? format(new Date(result.information.offset_at), 'HH:mm') : this.time_offset
          const emailAdmin = [
            'sato@uniqstyle.co.jp',
            'kawakatsu@uniqstyle.co.jp',
            'oshika@uniqstyle.co.jp',
            'kentaro@uniqstyle.co.jp'
          ]
          this.isShowButtonApproved = false
          if (result.information.is_send_mail === '1') {
            this.isConfirmReturn = true
          }
          console.log(this.$store.getters['User/data']['email'])
          if (result.information.is_send_mail === '1' && emailAdmin.includes(this.$store.getters['User/data']['email']) !== false) {
            this.isShowButtonApproved = true
          }
          let indexIsApproved = _.findIndex(this.adminStatus, (o) => { return o.email === this.$store.getters['User/data']['email'] })

          if (indexIsApproved !== -1) {
            this.isApprivedDisable = this.adminStatus[indexIsApproved].status === '1'
          }
          this.isShowLastConfirm = (_.findIndex(this.adminStatus, (o) => { return o.status === '0' }) === -1)
          this.isLastConfirm = result.information.is_last_confirm
        } else {
          return Promise.reject(new Error(result.message))
        }
      }).catch(function (error) {
        console.log('SingleReturnPartner:getReturnPartnerDetails:catch(error): ', error)
        return Promise.reject(new Error(this.translations('return_partner.notice_failed')))
      }).finally(() => {
        this.isLoading = false
      })
    },

    getAllReturnDetail () {
      this.isLoading = true
      let params = {
        return_partner_id: this.returnPartnerId,
        is_all: true
      }
      this.$http.post(this.$api_url.return_partner_details, params).then(response => {
        const result = response.data
        if (result || result.status === true) {
          this.allReturnDetails = result.details
        }
      }).catch(err => {
        this.$toastr.error(this.translations('return_partner.message_error') + err.message, this.translations('common.error'))
      }).finally(() => {
        this.isLoading = false
        this.evidentFile = []
      })
    },

    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
      }
      if (!taxIncluded) { // 税込以外
        return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
      } else {
        return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
      }
    },

    prepareDetails (data) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price
      data.total_unit_price_inctax = data.quantity * data.unit_price_inctax

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        if (!this.taxIncluded) { // 税抜
          data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
        } else {
          data.total_unit_price = this.$util.getIncludeTax(data.total_unit_price_inctax, data.tax_rate)
        }
      }

      return data
    },

    prepareTotalDetails (data) {
      data.total_cost_detail = data.quantity * data.row_price
      data.total_unit_price_detail = data.quantity * data.unit_price
      data.total_unit_price_inctax_detail = data.quantity * data.unit_price_inctax

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax_detail = data.total_cost_detail
        data.total_unit_price_inctax_detail = data.total_unit_price_detail
      } else {
        data.total_cost_inctax_detail = this.$util.getIncludeTax(data.total_cost_detail, data.tax_rate)
        if (!this.taxIncluded) { // 税抜
          data.total_unit_price_inctax_detail = this.$util.getIncludeTax(data.total_unit_price_detail, data.tax_rate)
        } else {
          data.total_unit_price_detail = this.$util.getIncludeTax(data.total_unit_price_inctax_detail, data.tax_rate)
        }
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalDebt = 0

      this.returnDetails.forEach(v => {
        if (!this.taxIncluded) { // 税抜
          this.grandTotalUnitPrice += Number(v.total_unit_price)
          if (v.return_status_id === 1) {
            this.grandTotalDebt += Number(v.total_cost)
          }
        } else {
          this.grandTotalUnitPriceIncTax += Number(v.total_unit_price_inctax)
          if (v.return_status_id === 1) {
            this.grandTotalDebtIncTax += Number(v.total_cost_inctax)
          }
        }
      })

      if (!this.taxIncluded) { // 税抜
        this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
        this.grandTotalDebtIncTax = this.$util.getIncludeTax(this.grandTotalDebt, this.taxRate)
      } else {
        this.grandTotalUnitPrice = this.$util.getExcludeTax(this.grandTotalUnitPriceIncTax, this.taxRate)
        this.grandTotalDebt = this.$util.getExcludeTax(this.grandTotalDebtIncTax, this.taxRate)
      }
    },

    calcGrandTotalsDetail () {
      this.grandTotalUnitPriceDetail = 0
      this.grandTotalDebtDetail = 0

      this.allReturnDetails.forEach(v => {
        if (!this.taxIncluded) { // 税抜
          this.grandTotalUnitPriceDetail += Number(v.total_unit_price_detail)
          if (v.return_status_id === 1) {
            this.grandTotalDebtDetail += Number(v.total_cost_detail)
          }
        } else {
          this.grandTotalUnitPriceIncTaxDetail += Number(v.total_unit_price_inctax_detail)
          if (v.return_status_id === 1) {
            this.grandTotalDebtIncTaxDetail += Number(v.total_cost_inctax_detail)
          }
        }
      })

      if (!this.taxIncluded) { // 税抜
        this.grandTotalUnitPriceIncTaxDetail = this.$util.getIncludeTax(this.grandTotalUnitPriceDetail, this.taxRate)
        this.grandTotalDebtIncTaxDetail = this.$util.getIncludeTax(this.grandTotalDebtDetail, this.taxRate)
      } else {
        this.grandTotalUnitPriceDetail = this.$util.getExcludeTax(this.grandTotalUnitPriceIncTaxDetail, this.taxRate)
        this.grandTotalDebtDetail = this.$util.getExcludeTax(this.grandTotalDebtIncTaxDetail, this.taxRate)
      }
    },

    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()} (${Number(valIncTax).toLocaleString()})`
      } else {
        return `${Number(valIncTax).toLocaleString()} (${Number(val).toLocaleString()})`
      }
    },

    refresh (id) { // number-container
      var element = document.querySelectorAll("[id='" + id + "']")
      for (var i = 0; i < element.length; i++) {
        let $this = $(element[i])
        $this.val(Number($this.val())) // TO NUMBER
        $this.next().text((+$this.val()).toLocaleString()) // REFRESH
      }
    },
    numbers (index, target) {
      this.returnDetails[index][target] = this.returnDetails[index][target].toString().replace(/[^0-9.-]/g, '')
    },

    openAddDetailModal () {
      this.$refs.openAddDetailModal.click()
    },

    async getBoundProduct () {
      try {
        const response = await this.$http.post(this.$api_url.return_bound_product, { return_id: this.returnPartnerId })
        const result = response.data
        if (result.status === true) {
          this.setItems = result.list
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      } catch (error) {
        console.log('SingleReturn:getBoundProduct:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    __b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },

    popoverButtons () {
      window.$("button[data-toggle='popover-x']").each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
      return Promise.resolve()
    },

    getTextResult (detail) {
      return detail.test_result ? detail.test_result : '-------------'
    },

    /**
     * @param field : sales information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref, propToUpdate) {
      let $this = this
      let val = ''
      const rg = /^\s+$/
      if (
        !value ||
        value === '-' ||
        value === '' ||
        rg.test(value) === true ||
        typeof value === 'undefined'
      ) {
        this.$refs[ref].innerText = '----------'
        val = ''
        if (field === 'applied_at') {
          this.returnDetails = []
        }
      } else if (field === 'shipped_at' || field === 'approved_at' || field === 'offset_at') {
        this.$refs[ref].innerText = format(new Date(value), 'yyyy/MM/dd HH:mm')
        val = format(new Date(value), "yyyy-MM-dd'T'HH:mm")
      } else if (field === 'requester_id') {
        val = 0
        this.personals.forEach((v) => {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            this.returnInfo.requester_name = v.name
            val = v.id
          }
        })
      } else if (field === 'applied_at') {
        this.$refs[ref].innerText = format(new Date(value), 'yyyy/MM/dd HH:mm')
        val = format(new Date(value), "yyyy-MM-dd' 'HH:mm")
        let offsetDate = this.returnInfo.applied_at ? format(new Date(this.returnInfo.applied_at), "yyyy-MM-dd' 'HH:mm") : ''
        if (this.tempDetails.length > 0 && offsetDate !== val) {
          this.returnDetails = []
        }
      } else {
        if (!propToUpdate) {
          this.$refs[ref].innerText = value
          val = value
        }
      }
      if (propToUpdate) {
        propToUpdate[field] = value
      } else {
        this.returnInfo[field] = val
      }
      window.$('#popover-' + ref).popoverX('hide')
    },

    deleteDetail (i) {
      this.returnDetails.splice(i, 1)
    },

    async listPersonals () {
      try {
        let cList = await this.$http.post(this.$api_url.return_partner_personal_list)
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'NewReturnPartners:listPersonals')

        if ($data.success === true) {
          this.personals = $data.data
        } else {
          this.personals = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        console.log('NewReturnPartners:listPersonals:catch(error): ', JSON.stringify(error))
        this.$toastr.error(this.translations('return_partner.notice_failed'), this.translations('common.error'))
      }
    },

    async updateReturn () {
      try {
        if (!this.returnInfo.applied_at) {
          this.$toastr.warning(this.translations('return_partner.notice_applied_date'))
          return
        }

        if (!this.returnInfo.approved_at) {
          this.$toastr.warning(this.translations('return_partner.notice_approved_date'))
          return
        }

        if (!this.returnInfo.offset_at) {
          this.$toastr.warning(this.translations('return_partner.notice_offset_date'))
          return
        }

        if (this.returnDetails.length < 1) {
          this.$toastr.warning(this.translations('return_partner.notice_enter_details_line'))
          return
        }

        this.isLoading = true
        this.tempInfo.applied_at = format(new Date(this.returnInfo.applied_at), "yyyy-MM-dd'T'HH:mm:ss")
        this.tempInfo.shipped_at = this.returnInfo.shipped_at ? format(new Date(this.returnInfo.shipped_at), "yyyy-MM-dd'T'HH:mm:ss") : ''
        this.tempInfo.approved_at = format(new Date(this.returnInfo.approved_at), "yyyy-MM-dd'T'HH:mm:ss")
        this.tempInfo.offset_at = format(new Date(this.returnInfo.offset_at), "yyyy-MM-dd'T'HH:mm:ss")

        let originalDetails = this.originalDetails
        let returnDetailRemoves = originalDetails.filter(originalDetail => !this.tempDetails.some(tempDetail => originalDetail.id === tempDetail.id))
        let newReturnDetails = this.allReturnDetails.filter(allReturnDetail => !returnDetailRemoves.some(returnDetailRemove => allReturnDetail.id === returnDetailRemove.id))
        this.tempDetails.forEach(tempDetail => {
          if (!tempDetail.id) {
            const { productList, ...rest } = tempDetail
            newReturnDetails.push(rest)
          }
        })
        let paramUpdate = {
          return_partner_id: this.returnPartnerId,
          information: this.tempInfo,
          details: newReturnDetails
        }
        console.log(paramUpdate)
        let updateReturn = await this.$http.post(this.$api_url.return_partner_update, paramUpdate)
        let $data = this.$invoiceTools.prepareResult(updateReturn.data, 'list', 'SingleReturn:updateReturn')
        if ($data.success === true) {
          this.isConfirmReturn = false
          this.$toastr.success(this.translations('return_partner.notice_save_success'), this.translations('common.success'))
          this.getReturnDetails()
          this.getAllReturnDetail()
          window.location.reload()
        } else {
          this.$toastr.error($data.data, this.translations('common.error'))
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('SingleReturn:updateReturn:catch(error): ', error)
        this.$toastr.error(this.translations('return_partner.notice_failed'), this.translations('common.error'))
      }
    },

    async deleteReturn () {
      this.$dialog.confirm(this.translations('return_partner.notice_delete'), {
        okText: this.translations('common.yes'),
        cancelText: this.translations('common.no')
      }).then(async () => {
        try {
          this.isLoading = true
          let deleteReturn = await this.$http.post(this.$api_url.return_partner_delete, { return_partner_id: this.returnPartnerId })
          let $data = this.$invoiceTools.prepareResult(deleteReturn.data, '', 'SingleReturnPartner:deleteReturnPartner')
          if ($data.success === true) {
            this.$toastr.success(this.translations('return_partner.notice_delete_success'), this.translations('common.success'))
            this.$router.replace({ name: 'archive-return-partners' })
          } else {
            this.$toastr.error($data.data, this.translations('common.error'))
          }
          setTimeout(() => { this.isLoading = false }, 1000)
        } catch (error) {
          console.log('SingleReturn:deleteReturn:catch(error): ', error)
          this.$toastr.error(this.translations('return_partner.notice_failed'), this.translations('common.error'))
        }
      })
    },

    withSetItem () {
      let ret = 0
      this.tempDetails.forEach(val => {
        if (val.set_status === 1) {
          ret += 1
        }
      })
      if (ret) {
        this.getBoundProduct()
        return true
      }
      return false
    },

    onChangeTestResult (detail, i) {
      this.updateField('test_result', this.tempDetails[i].test_result, ('test_result' + i), detail)
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_partner_detail_id: detail.id,
        test_result: detail.test_result
      }
      const self = this
      this.$http.post(this.$api_url.return_partner_change_test_result, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('検証結果を更新しました', 'Success')
          detail.test_result = response.data.test_result
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          detail.test_result = response.data.old_test_result
        }
      }).finally(function () {
        self.returnDetails[i] = detail
        self.isLoading = false
      })
    },

    onChangeTaxclass (detail) {
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        taxclass_id: detail.taxclass_id
      }
      const self = this
      this.$http.post(this.$api_url.return_change_taxclass, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('税区分を更新しました', 'Success')
          detail.taxclass_id = response.data.taxclass_id
        } else {
          self.$toastr.error(response.data.message, '更新に失敗しました')
          detail.taxclass_id = response.data.old_taxclass_id
        }
      }).finally(function () {
        self.isLoading = false
      })
    },

    onChangeUnitPrice (detail) {
      if (!detail.id) {
        if (!detail.taxclass_id) detail.taxclass_id = 1
        if (Number(detail.taxclass_id) === 1) { // 税区分（1:課税対象, 2:対象外）
          if (!this.taxIncluded) {
            detail.unit_price_inctax = this.$util.getIncludeTax(detail.unit_price, detail.tax_rate)
          } else {
            detail.unit_price = this.$util.getExcludeTax(detail.unit_price_inctax, detail.tax_rate)
          }
        } else {
          detail.unit_price_inctax = detail.unit_price
        }
        return
      }

      this.isLoading = true
      const params = {
        return_detail_id: detail.id,
        selling_price: detail.unit_price,
        selling_price_inctax: Number(detail.taxclass_id) === 1 ? this.$util.getIncludeTax(detail.unit_price, detail.tax_rate) : detail.unit_price
      }
      const self = this
      this.$http.post(this.$api_url.return_partner_change_selling_price, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(this.translations('return_partner.notice_update_unit_price_success'), this.translations('common.success'))
          detail.unit_price = response.data.selling_price
          detail.unit_price_inctax = response.data.selling_price_inctax
        } else {
          self.$toastr.error(response.data.message, this.translations('return_partner.processing_failed'))
          detail.unit_price = response.data.old_selling_price
          detail.unit_price_inctax = response.data.old_selling_price_inctax
        }
      }).finally(function () {
        self.isLoading = false
      })
    },

    onChangeRemarks (detail) {
      if (!detail.id) return

      this.isLoading = true
      const params = {
        return_partner_detail_id: detail.id,
        remarks: detail.remarks
      }
      const self = this
      this.$http.post(this.$api_url.return_partner_change_remarks, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success(this.translations('return_partner.notice_update_remarks_success'), this.translations('common.success'))
          detail.remarks = response.data.remarks
        } else {
          self.$toastr.error(response.data.message, this.translations('return_partner.processing_failed'))
          detail.remarks = response.data.old_remarks
        }
        location.reload()
      }).finally(function () {
        self.isLoading = false
      })
    },

    clickIsProcessed () {
      this.isLoading = true
      const params = {
        return_id: this.returnPartnerId,
        is_processed: Number(this.returnInfo.is_processed) === 0 ? 1 : 0
      }
      const self = this
      this.$http.post(this.$api_url.return_update_is_processed, params).then(function (response) {
        if (response.data.status) {
          self.$toastr.success('処理状態を更新しました', 'Success')
          self.getReturnDetails()
          self.getAllReturnDetail()
        } else {
          self.$toastr.error(response.data.message, '処理失敗')
          self.returnInfo.is_processed = response.data.old_is_processed
          self.originalInfo.is_processed = response.data.old_is_processed
        }
      }).finally(function () {
        self.isLoading = false
      })
    },

    toUnitPriceTaxLabel (data) {
      const taxIncluded = data.tax_included || this.taxIncluded
      if (taxIncluded) {
        return Number(data.unit_price).toLocaleString()
      } else {
        return Number(data.unit_price_inctax).toLocaleString()
      }
    },

    onChangePrice (key, detail) {
      const taxRate = Number(detail.tax_rate || this.taxRate)
      detail[key] = detail[key].replace(/[^0-9]/g, '')
      if (key === 'unit_price') {
        detail.unit_price_inctax = this.$util.getIncludeTax(detail[key], taxRate)
      } else if (key === 'unit_price_inctax') {
        detail.unit_price = this.$util.getExcludeTax(detail[key], taxRate)
      }
    },

    setSelectedRequester (value) {
      this.forceChange = !this.forceChange
      this.tempInfo.requester = value
    },

    typeProduct (type) {
      if (type === Condition.BAD) {
        return this.translations('return_partner.bad')
      } else if (type === Condition.OUTLET) {
        return this.translations('return_partner.outlet')
      } else {
        return this.translations('return_partner.good')
      }
    },

    productOrigin (productOrigin) {
      if (productOrigin === '0') {
        return this.translations('return_partner.overseas')
      } else if (productOrigin === '1') {
        return this.translations('return_partner.domestic')
      } else {
        return '----------'
      }
    },

    affectsInventory (affectsInventory) {
      if (affectsInventory === '0') {
        return this.translations('return_partner.not_reflect')
      } else if (affectsInventory === '1') {
        return this.translations('return_partner.reflect')
      } else {
        return '----------'
      }
    }
  }
}
</script>

<style>
#set-item-list{
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}
.is_processed {
  vertical-align: middle !important;
}
[for='checkallPrint'] {
  margin-bottom: 0;
  margin-left: 0.6rem;
}
[for='checkallStatus'] {
  margin-bottom: 0;
}
[for='checkStatus'] {
  margin-top: 7px;
  margin-right: 0.6rem;
}
</style>

<style scoped>
.input-date {
  width: 140px;
}
.upload-file-evident {
  /*display: flex;*/
}
.show_status {
  margin-left:5px;
  color:red;
}
.list-status {
  width: 160px;
  display: flex;
  margin-bottom: 5px;
}
.admin-name {
  width: 60%;
}
.popover-x.right > .arrow.status {
  left: -15px;
}
.popover-body.status {
  padding: 20px;
}
.close.status {
    position: absolute;
    top: 0;
    right: 3px;
}
.text-status {
  color: #106710;
}
.isShowButtonApproved {
  position: absolute;
  top: 0;
  right: 0;
}
.form-line-po {
  position: relative;
}
.statusAllChecked{
  width: 0;
}
</style>
